import i18n from '@/language.js'
const { t } = i18n.global
import axios from 'axios'
import {auth_api,Config} from '@/api/plcore'
import toast from '@/utils/toast'
import logger from './logger'


const service = axios.create({
    baseURL:'',
    timeout: 10000
})

service.interceptors.request.use(
    config=>{
        if(config.baseURL) {
            service.baseURL = config.baseURL;
        }
        // 携带token
        var auth = auth_api.get_auth();
        auth = JSON.parse(auth)
        if(auth){
            config.headers.common['Authorization'] = 'Bearer '+auth['accessToken'];
        }
        return config;
    },
    error=>{
        // console.log(error);
        return Promise.reject(error);
    }
)

service.interceptors.response.use(
    async (response) => {
        if(response.status == 200 && response.data.code == 100) {
                var auth = JSON.parse(auth_api.get_auth(Config.ip));
                if(auth){
                    var refresh_token = auth['refreshToken'];
                    if(refresh_token){
                        const {status,data} = await axios({
                            method:'POST',
                            url:Config.remote()+'v2/Auth/GetNewToken',
                            data:{RefreshToken:refresh_token}
                        })
                        if(status == 200 && data) {
                            // 续期成功
                            if(data.Code == 0) {
                                auth_api.set_auth(Config.ip,data.Data.AccessToken,refresh_token);
                                response.config.headers.Authorization = 'Bearer '+data.Data.AccessToken;
                                return axios(response.config);
                            }
                        }
                    }
                }
                var authParams = JSON.parse(auth_api.get_auth_params());
                if(authParams){
                    const {data} = await axios({
                        method:'POST',
                        url:Config.remote()+'v2/Auth/Login',
                        data:{Identifier:authParams.identifier,Certificate:authParams.certificate}
                    });
                    if(data && data.Code == 0) {
                        auth_api.set_auth(Config.ip,data.Data.AccessToken,data.Data.RefreshToken);
                        response.config.headers.Authorization = 'Bearer ' + data.Data.AccessToken;
                        return axios(response.config);
                    }
                } else {
                    toast.show(t('shou_quan_can_shu_cuo_wu'));
                }
        } else if(response.status == 200 && response.data.code == 401){
			var userAgent = navigator.userAgent;
			if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)&&window.miniImsp) {
				toast.show('登陆状态已过期，请重新登录！')
			}else{
			    window.android.leaseRenewalExpires();
			}
		}else {
            if(response.status != 200){
                toast.show('http_code ' + response.status);
            }
        }
        return response;
    },
    error => {
        // logger.e(error);
        return Promise.reject(error);
    }
)

export default service;
